const defaultPropertiesUpdateFn = (name, value) => state => ({
  properties: {
    ...state.properties,
    [name]: value,
  },
});

export default defaultPropertiesUpdateFn;